import React from 'react'
import MwSpinnerButton from '../MwSpinnerButton'

const CardSummaryWithLoading = ({ label, loading, data, children, icon, reverse = false, className = '' }) => {
    const baseClass = `text-sm transition-all duration-300 hover:shadow-lg h-full p-5 flex-1 flex flex-col justify-between items-center gap-3 rounded-2xl border border-slate-100 ${className || 'bg-white shadow-sm'}`;

    return (
        <>
            {
                !reverse ?
                    <div className={baseClass}>
                        <div className='flex items-center gap-3 w-full'>
                            {icon && <div className='p-2 bg-slate-50 rounded-lg'><img src={icon} className='w-6 h-6' alt={label} /></div>}
                            <div className='text-slate-600 font-medium'>{label}</div>
                        </div>
                        <div className='text-center font-bold w-full text-2xl text-slate-800'>
                            {loading ?
                                <MwSpinnerButton isFullCenter={true} withLabel={false} /> :
                                children ? children : <div className='w-full pt-2'>{data}</div>
                            }
                        </div>
                    </div> :
                    <div className={`${baseClass} justify-center`}>
                        <div className='text-center font-bold w-full'>
                            {loading ?
                                <MwSpinnerButton withLabel={false} /> :
                                children ? children : <div className='w-full pt-2'>{data}</div>
                            }
                        </div>
                        <div className='text-slate-500 font-medium text-center'>{label}</div>
                    </div>
            }
        </>
    )
}

export default CardSummaryWithLoading